<template>
  <!-- <transition name="modal" > -->
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{onlySafari: isSafari}">
          <button class="modal-close-button" @click="$emit('close') & closeGA4Click('click', 'cerrar', 'popup informacion del producto')">X</button>
          <div class="modal-body-body">
            <slot name="body">
              <div class="img-top-container">
                <img :src="logo" />
              </div>
              <div class="info-container">
                <div class="info-col-middle col-img-product">
                  <img :src="botella" alt="Botella Tecate 0.0" />
                </div>
                <div class="info-col col-text-info" :class="{onlySafari: isSafari}">
                  <h5 class="mSection-title">Ingredientes:</h5>
                  <p class="mParagraph mText-2">
                    Agua, malta de <b>cebada</b>, almidón, saborizantes <br> naturales, 
                    extracto de lúpulo. CONTIENE: GLUTEN <b>(CEBADA)</b>. 
                  </p>
                  <h5 class="mSection-title" style="margin-top: 2vw;">DECLARACIÓN NUTRIMENTAL</h5>
                  <p class="mParagraph mText-2">
                    Contenido energético por envase 71.56 kcal (304.16 kJ). 
                    Tamaño de la porción 100 mL, Porciones por envase 3.55 
                    Contenido energético por porción 20.16 kcal (85.68 kJ), 
                    Proteínas 0 g, Grasas totales 0 g, Grasas Saturadas 0 g, 
                    Grasas Trans 0 mg, Hidratos de Carbono disponibles 5.04 g, 
                    Azúcares 2.36 g, Azúcares añadidos 0 g, Fibra dietética 
                    menos de 1 g, Sodio 3 mg.
                  </p>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import logo from '@/assets/TECATELOGO_ROJO.png';
import botella from '@/assets/BOTELLATECATE0.0.png';
import tagFunctions from '@/utils/tagFunctions.js'
import Bowser from "bowser";
export default {
  name: "ModalInfoProduct",
  data() {
    return {
      logo,
      botella,
      isSafari: false
    };
  },
  components: {},
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
  async mounted(){
    tagFunctions.user_interactionPush('view', 'popup informacion del producto', 'footer');
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/modalInfoProduct.scss";
</style>
   